import { setupWorker } from 'msw';
import { mswKnitHandler } from '@stitch-fix/knit/msw';
import { browserGraphHandlers } from './graph';

/**
 * Mocks that interact with the browser
 */
export const worker = setupWorker(mswKnitHandler(), ...browserGraphHandlers);
